import { useMemo } from 'react';

export const ScriptSource = {
  PRODUCTION:
    'https://onlyfy.com/wp-content/uploads/matomo/container_KclFfkei.js',
  PREVIEW:
    'https://preview.onlyfy.com/wp-content/uploads/matomo/container_p3ZzVomv.js',
};

export const getScript = (env) => {
  return useMemo(() => {
    if (env === 'production') {
      return ScriptSource.PRODUCTION;
    }
    return ScriptSource.PREVIEW;
  }, [env]);
};
